/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { CauseService } from './CauseService';

class CauseServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new CauseService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { CauseServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/CauseServiceProvider.js